<ngx-spinner bdOpacity="1" bdColor="rgba(97,197,212,0.07)" size="medium" color="#dd4b39" type="ball-spin-clockwise"
    fullScreen="true">
    <p style="color: #61c5d4;">Loading..</p>
</ngx-spinner>



<div *ngIf="!CustLogintoggle" [hidden]="isVerifyOtp" class="demo mt-0">
  <form [formGroup]="clientForm">
    <div class="empFormWidth flex-grow-1">
      <div class="my-3">
        <label class="form-label mb-2" for="card-email"  style = "font-family: 'Poly';">User ID <span class="error-asterisk">*</span></label>
        <input class="form-control" id="card-email" type="email" placeholder="Email Address" required formControlName="username"
          (keydown.enter)="moveFocus($event, passwordInput)"/>
          <div class="text-danger" *ngIf="(submitted || clientControls.username.touched) && clientControls.username.errors?.pattern">
            Enter a valid Username.
          </div>
          <div class="text-danger" *ngIf="(submitted || clientControls.username.touched) && clientControls.username.errors?.required">
            Enter a valid Username.
          </div>
      </div>
      <div class="mb-3">
        <div class="d-flex justify-content-between">
          <label class="form-label mb-2" for="card-password"  style = "font-family: 'Poly';">Password <span class="error-asterisk">*</span></label>
        </div>
        <input [type]="changeType ? 'password' : 'text'" class="form-control"
          placeholder="Password" required id="card-password"
          #passwordInput formControlName="password" (keyup.enter)="clientLogin()"/>
        <span class="form-control-feedback" (click)="toggleShow()">
          <i class=" p-1 "
            [ngClass]="visible ? 'fa fa-eye':'fa fa-eye-slash'"></i>
        </span>
        <div class="text-danger" *ngIf="(submitted || clientControls.password.touched) && clientControls.password.errors?.required">
          Enter a valid Password.
        </div>
      </div>
      <div class="row flex-between-center">
        <div class="col-auto">
          <div class="form-check mb-0">
            <input class="form-check-input" type="checkbox"
                id="card-checkbox" checked="checked" />
            <label class="form-check-label mb-0"
                for="card-checkbox"  style = "font-family: 'Poly';">Remember me</label>
          </div>
        </div>
        <div class="col-auto">
          <a class="fs--1" style="font-size: 10px!important;cursor: pointer;font-family: 'Poly';"
            routerLink="/auth/forget-password" >
            Forgot Password?
          </a>
        </div>
      </div>
      <div class="mb-3">
        <button class="login-btn d-block w-100 mt-3" type="button"
          [disabled]="isLoginBtn" (click)="clientLogin()">
          <span class="spinner-border spinner-border-sm" *ngIf="isLoginBtn"
              role="status" aria-hidden="true"></span>
          <span  style = "font-family: 'Poly';">Log in</span>
        </button>
      </div>
    </div>
  </form>
</div>

<button class="btn mt-2" data-bs-toggle="modal" data-bs-target="#sessionExistsModal" hidden id="trigger-modal"></button>

<div class="modal fade" id="sessionExistsModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 350px">
        <div class="modal-content position-relative">
            <div class="position-absolute top-0 end-0 mt-2 me-2 z-index-1">
                <a class="btn-close btn btn-sm btn-circle d-flex flex-center transition-base" data-bs-dismiss="modal"
                    aria-label="Close"></a>
            </div>
            <div class="modal-body p-0">
                <div class="rounded-top-lg py-3 ps-4 pe-6 bg-light">
                    <h2 class="mb-1 text-center font-weight-bold" style="font-weight: 500;font-family: 'Poppins';"
                        id="sessionModalLabel">
                        Session Already Exists
                    </h2>
                </div>
                <h4 class="text-center" style="font-family: 'Poppins';">
                    A session is already active. Would you like to close the register?
                </h4>
            </div>
            <div class="modal-footer justify-content-center">
                <a class="btn btn-outline-success" data-bs-dismiss="modal">Cancel</a>
                <a class="btn btn-outline-danger" (click)="redirectToCloseRegister()" data-bs-dismiss="modal">Redirect to Close Register</a>
            </div>
        </div>
    </div>
</div>


<!-- <main class="main" id="top">
  <div class="">
    <div class="container-fluid row min-vh-100 flex-center g-0">
      <div class="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 py-3 position-relative">
        <div class="card overflow-hidden z-index-1">
          <div class="card-body p-0">
            <div class="row g-0 h-100">
                <div class="col-sm-12 col-md-6 col-lg-6 bg-card-gradient">

                    <div class="position-relative pt-md-3 pb-md-7 light" style = "padding-top: 150px !important;">
                      <div class="z-index-1 position-relative p-4">

                          <p class="mt-2 d-flex">

                              <img src="assets/img/icons/spot-illustrations/Logo-2.png"
                                  alt="iceipts logo" width="40" height="40" style="position: absolute !important; top: -17% !important;left: 45%">
                              <img src="assets/img/icons/spot-illustrations/Logo-1.png"
                                  alt="iceipts logo" width="130" height="20" style = "margin:auto;">
                          </p>
                          <br><br>
                          <p class="opacity-75 text-white d-flex justify-content-center leftText">
                              The technology that looks impossible today will<br>be part of our life
                              tomorrow. Iceipts technology<br>creating difference.
                          </p>
                      </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 form-box" >

                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main> -->













<!-- <main class="main" id="top">
    <div class="">
        <div class="container-fluid row min-vh-100 flex-center g-0">
            <div class="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-7 py-3 position-relative">

                <div class="card overflow-hidden z-index-1">
                    <div class="card-body p-0">
                        <div class="row g-0 h-100">
                            <div class="col-sm-12 col-md-6 col-lg-6 bg-card-gradient">

                                <div class="position-relative pt-md-3 pb-md-7 light" style = "padding-top: 150px !important;">
                                  <div class="z-index-1 position-relative p-4">

                                      <p class="mt-2 d-flex">

                                          <img src="assets/img/icons/spot-illustrations/Logo-2.png"
                                              alt="iceipts logo" width="40" height="40" style="position: absolute !important; top: -17% !important;left: 45%">
                                          <img src="assets/img/icons/spot-illustrations/Logo-1.png"
                                              alt="iceipts logo" width="130" height="20" style = "margin:auto;">
                                      </p>
                                      <br><br>
                                      <p class="opacity-75 text-white d-flex justify-content-center leftText">
                                          The technology that looks impossible today will<br>be part of our life
                                          tomorrow. Iceipts technology<br>creating difference.
                                      </p>
                                  </div>
                              </div>
                            </div>
                            <div class="col-sm-12 col-md-6 col-lg-6 form-box" >
                                <div *ngIf="!CustLogintoggle" [hidden]="isVerifyOtp" class="demo">
                                    <button mat-flat-button style="color: #8692A6;" (click)="backToRoleSelecetion()">
                                        <span  style = "font-family: 'Poppins';">< Back</span>
                                      </button>
                                    <form [formGroup]="clientForm">
                                        <div class="p-4 flex-grow-1">
                                            <div class="row flex-between-center">
                                                <div class="col-12 ">
                                                    <p style="font-weight: 500;color: #000000;font-family: 'Poppins', sans-serif;font-size: 20px;">
                                                        Sign In As Employee!</p>
                                                </div>
                                                <div class="toggle-text col-12 fs-0 my-2">
                                                    <hr class="top-line my-2" style="opacity: 20%;">
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <label class="form-label" for="card-email"  style = "font-family: 'Poppins';">User ID <span class="error-asterisk">*</span></label>
                                                <input class="form-control" id="card-email" type="email"
                                                    placeholder="Email Address" required formControlName="username"
                                                    (keydown.enter)="moveFocus($event, passwordInput)"/>
                                                    <div *ngIf="clientForm.get('username').hasError('required') && clientForm.get('username').touched" class="text-danger">User ID is required.</div>


                                            </div>
                                            <div class="mb-3">
                                                <div class="d-flex justify-content-between">
                                                    <label class="form-label" for="card-password"  style = "font-family: 'Poppins';">Password <span class="error-asterisk">*</span></label>
                                                </div>
                                                <input [type]="changeType ? 'password' : 'text'" class="form-control"
                                                    placeholder="Password" required id="card-password"
                                                    #passwordInput formControlName="password" (keyup.enter)="clientLogin()"/>
                                                <span class="form-control-feedback" (click)="toggleShow()">
                                                    <i class=" p-1 "
                                                        [ngClass]="visible ? 'fa fa-eye':'fa fa-eye-slash'"></i>
                                                </span>
                                                <div *ngIf="clientForm.get('password').hasError('required') && clientForm.get('password').touched" class="text-danger">Password is required.</div>
                                            </div>
                                            <div class="row flex-between-center">
                                                <div class="col-auto">
                                                    <div class="form-check mb-0">
                                                        <input class="form-check-input" type="checkbox"
                                                            id="card-checkbox" checked="checked" />
                                                        <label class="form-check-label mb-0"
                                                            for="card-checkbox"  style = "font-family: 'Poppins';">Remember me</label>
                                                    </div>
                                                </div>
                                                <div class="col-auto">
                                                    <a class="fs--1" style="font-size: 10px!important;cursor: pointer;font-family: 'Poppins';"
                                                    routerLink="/auth/forget-password" >Forgot
                                                        Password?</a>
                                                </div>
                                            </div>
                                            <div class="mb-3">
                                                <button class="login-btn d-block w-100 mt-3" type="button"
                                                    [disabled]="isLoginBtn" (click)="clientLogin()">
                                                    <span class="spinner-border spinner-border-sm" *ngIf="isLoginBtn"
                                                        role="status" aria-hidden="true"></span>
                                                    <span  style = "font-family: 'Poppins';">Log in</span>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main> -->


